import { cashnator, isNumeric } from "./functions";

export const gradingTypes = {
    "raw": "Manafix RAW",
    "standard": "Manafix STANDARD",
    "premium": "Manafix PREMIUM",
    "pre": "Pré-Grading",
    "no_subgrades": "Grading sem Subgrades",
    "cert_only": "Somente Certificação"
}

const DEFAULT_PRE_LACRE_FORMAT_LABELS = {
    "with_subgrades": "Pré: lacre com subgrades (+R$49/item se prosseguir)",
    "without_subgrades": "Pré: lacre sem subgrades (+R$35/item se prosseguir)"
}

// Com `config` (config.products.pre.preLacre.*Cents), usa os valores reais da
// precificação. Sem `config`, mantém os textos default — telas que ainda não
// carregam a config de preços (wizards de criação, mobile) chamam sem argumento.
export const preLacreFormatLabels = (config) => {
    const preLacre = config?.products?.pre?.preLacre;
    if (!preLacre) {
        return DEFAULT_PRE_LACRE_FORMAT_LABELS;
    }
    return {
        "with_subgrades": `Pré: lacre com subgrades (+${cashnator(preLacre.withSubgradesCents)}/item se prosseguir)`,
        "without_subgrades": `Pré: lacre sem subgrades (+${cashnator(preLacre.withoutSubgradesCents)}/item se prosseguir)`
    };
}

const DEFAULT_AUTOGRAPH_LABEL = "Avaliação de autógrafo (+R$20/item na base)";

// Label do checkbox de avaliação de autógrafo. Com `config` (config.fees.autographCents)
// usa o valor real; sem config mantém o texto default.
export const autographLabel = (config) => {
    const cents = config?.fees?.autographCents;
    if (!Number.isFinite(cents)) {
        return DEFAULT_AUTOGRAPH_LABEL;
    }
    return `Avaliação de autógrafo (+${cashnator(cents)}/item na base)`;
}

const DEFAULT_PRE_LACRE_OPTION_LABELS = {
    "with_subgrades": "Com subgrades (+R$49 se lacrar)",
    "without_subgrades": "Sem subgrades (+R$35 se lacrar)"
}

// Labels curtos das opções de pré-lacre usados no editModal (texto diferente
// dos labels de preLacreFormatLabels, que são usados nos wizards de criação).
export const preLacreOptionLabels = (config) => {
    const preLacre = config?.products?.pre?.preLacre;
    if (!preLacre) {
        return DEFAULT_PRE_LACRE_OPTION_LABELS;
    }
    return {
        "with_subgrades": `Com subgrades (+${cashnator(preLacre.withSubgradesCents)} se lacrar)`,
        "without_subgrades": `Sem subgrades (+${cashnator(preLacre.withoutSubgradesCents)} se lacrar)`
    };
}

const gradingTypeAliases = {
    regular: "standard"
}

export const normalizeGradingType = (gradingType) => {
    if (!gradingType) {
        return "";
    }
    const lowerType = `${gradingType}`.toLowerCase();
    return gradingTypeAliases[lowerType] || lowerType;
}

export const getGradingTypeLabel = (gradingType) => {
    const normalized = normalizeGradingType(gradingType);
    return gradingTypes[normalized] || gradingType;
}

export const getPreLacreFormatLabel = (preLacreFormat, config) => {
    return preLacreFormatLabels(config)[preLacreFormat] || preLacreFormat;
}

export const gradingTypeSupportsSubgrades = (gradingType, preLacreFormat) => {
    const normalized = normalizeGradingType(gradingType);
    if (["no_subgrades", "cert_only"].includes(normalized)) {
        return false;
    }
    if (normalized === "pre") {
        return preLacreFormat !== "without_subgrades";
    }
    return true;
}

export const gradingTypeSupportsGeneralScore = (gradingType) => {
    const normalized = normalizeGradingType(gradingType);
    return normalized !== "cert_only";
}

export const gradingTypeSupportsAutograph = (gradingType) => {
    return normalizeGradingType(gradingType) !== "premium";
}

export const priorityTypes = {
    "none": "Sem Prioridade",
    "low": "Prioridade Baixa",
    "mid": "Prioridade Média",
    "high": "Prioridade Alta",
    "max": "Prioridade Máxima"
}

export const getScoreTitle = (score) => {
    if (!isNumeric(score)) {
        if (score === "EP") {
            return "Event Promo";
        }
        if (score === "N/P") {
            return "Not Graded";
        }
    }
    const scoreNumber = parseFloat(score);
    if (scoreNumber >= 10) {
        return "Pristine";
    }
    if (scoreNumber >= 9.5) {
        return "Gem Mint"
    }
    if (scoreNumber >= 9) {
        return "Mint"
    }
    if (scoreNumber >= 8.5) {
        return "Near Mint +"
    }
    if (scoreNumber >= 8) {
        return "Near Mint"
    }
    if (scoreNumber >= 7.5) {
        return "Slightly Played +"
    }
    if (scoreNumber >= 7) {
        return "Slightly Played"
    }
    if (scoreNumber >= 6) {
        return "Slightly Played -"
    }
    if (scoreNumber >= 5) {
        return "Moderately Played +"
    }
    if (scoreNumber >= 4.5) {
        return "Moderately Played"
    }
    if (scoreNumber >= 4) {
        return "Moderately Played -"
    }
    if (scoreNumber >= 3.5) {
        return "Heavily Played +"
    }
    if (scoreNumber >= 3) {
        return "Heavily Played"
    }
    if (scoreNumber >= 2.5) {
        return "Heavily Played -"
    }
    if (scoreNumber >= 2) {
        return "Damaged"
    }
    if (scoreNumber >= 1.5) {
        return "Poor +"
    }
    if (scoreNumber >= 1) {
        return "Poor"
    }
}
